import { render, staticRenderFns } from "./CurationWriteLink.vue?vue&type=template&id=3c9f16bb&scoped=true"
import script from "./CurationWriteLink.vue?vue&type=script&lang=js"
export * from "./CurationWriteLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9f16bb",
  null
  
)

export default component.exports